/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const homePages = {
    BrowseHome: () => import('@/BrowseHome'),
    Feed: () => import('@/blackbolt/Feed'),
    chatPaneEntry: () => import('@/blackbolt/chat/chatPaneEntry'),
    MusicHome: () => import('@/music/MusicHome'),
    TastesPage: () => import('@/tastes/TastesPage'),
}
